import { sortControlStyles } from "@insite/content-library/Widgets/MyLists/MyListsSortControl";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import ChevronsUpDown from "@insite/mobius/Icons/ChevronsUpDown";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

sortControlStyles.wrapper = {
    css: css`
        display: flex;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                null,
                null,
                null,
                css`
                    width: 300px;
                `,
                css`
                    width: 300px;
                `,
            ])}
    `,
};

// sortControlStyles.select = {
//     cssOverrides: {
//         inputSelect: css`
//             border-radius: 40px;
//         `,
//     },
// };


sortControlStyles.sortByOverflowMenu = {
    iconProps: { src: ChevronsUpDown },
    cssOverrides: {
       menu:css`
          position:relative !important;
          top:0px !important;
          left:0px !important;
          z-index: 999 !important;
        `
    },
};
